export const SLICE_NAME: string = 'scheduleBuilderSession';
